(function () {
  const sections = document.querySelectorAll('[data-barf-ingredients]');
  if (!sections.length) return;

  sections.forEach((section) => {
    section.classList.add('fbi-js');

    const revealItems = section.querySelectorAll('.fbi-reveal, .fbi-reveal-card');
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('fbi-is-visible');
        observer.unobserve(entry.target);
      });
    }, {
      threshold: 0.14,
      rootMargin: '0px 0px -42px 0px'
    });

    revealItems.forEach((item, index) => {
      if (!item.style.getPropertyValue('--fbi-delay')) {
        item.style.setProperty('--fbi-delay', `${index * 80}ms`);
      }
      observer.observe(item);
    });

    const tabs = section.querySelectorAll('[data-fbi-tab]');
    const cards = section.querySelectorAll('[data-fbi-card]');

    const setCategory = (category) => {
      tabs.forEach((tab) => {
        tab.classList.toggle('is-active', tab.getAttribute('data-fbi-tab') === category);
      });

      cards.forEach((card) => {
        const matches = card.getAttribute('data-fbi-category') === category;
        card.classList.toggle('is-hidden', !matches);
      });
    };

    tabs.forEach((tab) => {
      tab.addEventListener('click', () => {
        setCategory(tab.getAttribute('data-fbi-tab'));
      });
    });

    setCategory('muskelfleisch');
  });
})();
